import { action, observable } from "mobx";

import { ok } from "shared/utils";

import codeMapRepository from "./code.map.repository";
import CodeMapModel from "./code.map.model";

export class CodeMapStore {
  //===========================================================================

  rootStore;
  @observable isLoading = true;
  @observable codeMaps = [];
  @observable mapInfo = {};

  constructor(rootStore) {
    this.rootStore = rootStore;
  }
  //===========================================================================

  @action
  setCodeMaps(codeMaps) {
    this.codeMaps = codeMaps;
    this.isLoading = false;
  }
  @action
  clearCodeMaps() {
    this.codeMaps = [];
    this.isLoading = true;
  }

  @action
  changeInput(name, value) {
    this.formData[name] = value;
  }

  @action
  setMapInfo(mapInfo) {
    this.mapInfo = mapInfo;
    this.isLoading = false;
  }
  @action
  clearMapInfo() {
    this.mapInfo = {};
    this.isLoading = true;
  }
  //===========================================================================

  async loadCodeMaps(params) {
    this.clearCodeMaps();
    const res = await codeMapRepository.findAll(params);
    ok(this, res, data => {
      this.setCodeMaps(
        data.codeMaps.map(codeMap => {
          codeMap.character = JSON.parse(codeMap.character);
          codeMap.coins = JSON.parse(codeMap.coins);
          codeMap.obstacles = JSON.parse(codeMap.obstacles);
          codeMap.cmds = JSON.parse(codeMap.cmds);
          return new CodeMapModel(codeMap);
        })
      );
    });
    this.initCodeMap();
  }

  changeCodeMap(uid) {
    let idx = this.codeMaps.findIndex(codeMap => codeMap.uid === uid);
    this.setMapInfo(this.codeMaps[idx]);
    
  }

  initCodeMap() {
    if (this.codeMaps.length > 0) this.setMapInfo(this.codeMaps[0]);
  }
  //===========================================================================
}
